(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('companyParameters', CompanyParameters)

    /** @ngInject */
    function CompanyParameters($rootScope, LoadingHelper, ParameterService, CompanyParameterService, UtilHelper, PATHS) {
        function CompanyParametersController() {
            const vm = this;

            vm.getNumber = num => {
                return new Array(num);
            }

            vm.addParameter = () => {
                vm.amountOfParameters++;
            }

            vm.removeParameter = (companyParameterId, index) => {
                if (!companyParameterId) {
                    vm.companyParameters.splice(index, 1);
                    vm.amountOfParameters--;
                    return;
                }

                LoadingHelper.startLoading('.plus-holder');

                CompanyParameterService
                    .deleteData(companyParameterId)
                    .then(() => {
                        vm.companyParameters.splice(index, 1);
                        vm.amountOfParameters--;

                        UtilHelper.successCallback('delete');
                        LoadingHelper.stopLoading('.plus-holder');
                    }, errorCallback);
            }

            vm.getParameters = () => {
                LoadingHelper.startLoading('.paramter-container', true);

                return ParameterService
                    .getAll()
                    .then(success => {
                        vm.parameters = success.Registers;
                        LoadingHelper.stopLoading('.paramter-container')
                    }, error => {
                        UtilHelper.errorCallback(error);
                        LoadingHelper.stopLoading('.paramter-container')
                    })
            }

            vm.saveCompanyParameters = () => {
                LoadingHelper.startLoading('.plus-holder');

                const companyParametersPost = vm.companyParameters.reduce((acc, cur) => {
                    acc.push({
                        ...cur,
                        CompanyId: vm.companyId
                    })

                    return acc;
                }, []);

                CompanyParameterService
                    .post(companyParametersPost)
                    .then(successCallback, errorCallback);
            }

            init();

            function successCallback(success) {
                vm.companyParameters = success;

                UtilHelper.successCallback('update');
                LoadingHelper.stopLoading('.plus-holder');
            }

            function errorCallback(error) {
                LoadingHelper.stopLoading('.plus-holder');
                UtilHelper.errorCallback(error);
            }

            function init() {
                vm.companyParameters = [];
                vm.parameters = [];
                vm.getParameters();
            }
        }

        function link(scope, element, attrs, ctrl) {
            const callbackInit = () => {
                ctrl.amountOfParameters = 0;
                ctrl.companyParameters = ctrl.currentParameters || [];

                if (ctrl.companyParameters && ctrl.companyParameters.length)
                    ctrl.amountOfParameters = ctrl.companyParameters.length;
            }

            if (scope.canUserEdit) {
                ctrl.getParameters()
                    .then(callbackInit);
            } else {
                ctrl.parameters = ctrl.currentParameters.reduce((acc, cur) => {
                    if (!acc.find(x => x.Id == cur.ParameterId))
                        acc.push(cur.Parameter);

                    return acc;
                }, []);

                callbackInit();
            }
        }

        return {
            bindToController: true,
            controller: CompanyParametersController,
            controllerAs: 'vm',
            link: link,
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/company-parameters/company-parameters.html`,
            scope: {
                currentParameters: '=',
                companyId: '=',
                canUserEdit: '='
            }
        }
    }
}());